import { render, staticRenderFns } from "./CodeRecordDetailView.vue?vue&type=template&id=61548527&scoped=true"
import script from "./CodeRecordDetailView.vue?vue&type=script&lang=js"
export * from "./CodeRecordDetailView.vue?vue&type=script&lang=js"
import style0 from "./CodeRecordDetailView.vue?vue&type=style&index=0&id=61548527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61548527",
  null
  
)

export default component.exports